export default {"src":"/_next/static/media/en.53b0f7d9.svg","height":480,"width":640};